
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const CatalogPage = lazy(() => import('../pages/catalog/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const DeliveryPage = lazy(() => import('../pages/delivery/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const ValentinePage = lazy(() => import('../pages/valentine/page'));
const PaquesPage = lazy(() => import('../pages/paques/page'));
const FeteMeresPage = lazy(() => import('../pages/fete-meres/page'));
const FetePeresPage = lazy(() => import('../pages/fete-peres/page'));
const FeteTravailPage = lazy(() => import('../pages/fete-travail/page'));
const JourneeFemmePage = lazy(() => import('../pages/journee-femme/page'));
const NoelPage = lazy(() => import('../pages/noel/page'));
const EvenementsFestifsPage = lazy(() => import('../pages/evenements-festifs/page'));
const SouvenirsInvitesPage = lazy(() => import('../pages/souvenirs-invites/page'));
const BouquetMarieePage = lazy(() => import('../pages/bouquet-mariee/page'));
const BouquetDamesPage = lazy(() => import('../pages/bouquet-dames/page'));
const BraceletFleursPage = lazy(() => import('../pages/bracelet-fleurs/page'));
const FleurPochePage = lazy(() => import('../pages/fleur-poche/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/a-propos',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/catalogue',
    element: <CatalogPage />,
  },
  {
    path: '/livraison',
    element: <DeliveryPage />,
  },
  {
    path: '/produit/:id',
    element: <ProductDetailPage />,
  },
  {
    path: '/saint-valentin',
    element: <ValentinePage />,
  },
  {
    path: '/journee-femme',
    element: <JourneeFemmePage />,
  },
  {
    path: '/paques',
    element: <PaquesPage />,
  },
  {
    path: '/fete-meres',
    element: <FeteMeresPage />,
  },
  {
    path: '/fete-peres',
    element: <FetePeresPage />,
  },
  {
    path: '/fete-travail',
    element: <FeteTravailPage />,
  },
  {
    path: '/noel',
    element: <NoelPage />,
  },
  {
    path: '/evenements-festifs',
    element: <EvenementsFestifsPage />,
  },
  {
    path: '/souvenirs-invites',
    element: <SouvenirsInvitesPage />,
  },
  {
    path: '/bouquet-mariee',
    element: <BouquetMarieePage />,
  },
  {
    path: '/bouquet-dames',
    element: <BouquetDamesPage />,
  },
  {
    path: '/bracelet-fleurs',
    element: <BraceletFleursPage />,
  },
  {
    path: '/fleur-poche',
    element: <FleurPochePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
